import { render, staticRenderFns } from "./JobQuotesBusinessRow.vue?vue&type=template&id=c72209de"
import script from "./JobQuotesBusinessRow.vue?vue&type=script&lang=js"
export * from "./JobQuotesBusinessRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconMapMarkerAlt: require('/opt/atlassian/pipelines/agent/build/components/icon/IconMapMarkerAlt.vue').default,IconCalendarAlt: require('/opt/atlassian/pipelines/agent/build/components/icon/IconCalendarAlt.vue').default,IconPoundSign: require('/opt/atlassian/pipelines/agent/build/components/icon/IconPoundSign.vue').default,JobQuoteBookingRow: require('/opt/atlassian/pipelines/agent/build/components/job/JobQuoteBookingRow.vue').default})
